import './App.css';
import React, {useEffect, useState} from 'react';
import axios from "axios";
import { Mapper } from './components/Mapper';

function App() {
  const [boothData, setboothData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Replace these with your actual API requests
        const apiRequest1 = axios.get('https://techpoint.africa/wp-json/wp/v2/exhibition-booth?_fields=title,acf&per_page=100');
        const apiRequest2 = axios.get('https://techpoint.africa/wp-json/wp/v2/exhibition-booth?_fields=title,acf&per_page=100&page=2');

        const responses = await Promise.all([apiRequest1, apiRequest2]);

        const data1 = responses[0].data;
        const data2 = responses[1].data;

        setboothData([...data1, ...data2]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);
  // useEffect(() => {
  //   axios.get("http://localhost:1337/api/exhibition-booths?pagination[page]=1&pagination[pageSize]=250", {
  //     headers: {
  //       Authorization: `bearer 8a7b92af4c86881153aca01090b7166b451e0da57097b5729922ac22956c5e57036bc7756e9705407d7c8901f63c840ddb97edf41196532613be1899beb0cf909492962a5076b53eba9e562383435a982d037e5e2e3d5968dacb24fed89dde3599710c2cb773bac3ab479faeadca8409ce83bba488f76174c6876386ba5cf9c9`
  //     }
  //   }).then((response) => {
  //     setboothData(response.data.data)
  //   });
  // }, []);
  if(boothData < 1) return <div></div>
  return (
    <div className="App">
      {/* <div className='box-info'>
        <h3>Click on a box to see booth information!</h3>
      </div> */}
      <Mapper boothData={boothData} />
    </div>
  );
}

export default App;
